import Vue from "vue";
import App from "./App.vue";
import store from "./store";
import i18n from "./i18n";
import router from "./router";
import DefaultLayout from "@/layouts/DefaultLayout";
import AuthLayout from "@/layouts/AuthLayout";
import PanelLayout from "@/layouts/PanelLayout";

import * as Sentry from "@sentry/vue";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import VueGoodTablePlugin from "vue-good-table";
import "vue-good-table/dist/vue-good-table.css";
import SvgSprite from "vue-svg-sprite";
import VueFlags from "@growthbunker/vueflags";

import {helper} from "./helpers/copyCode";
import moment from "moment";
import Notifications from "vue-notification";
import Vuelidate from "vuelidate";

Vue.prototype.$moment = moment;
Vue.prototype.$helper = helper;
Vue.use(Vuelidate);
Vue.use(VueGoodTablePlugin);

Vue.use(SvgSprite, {
  url: "/images/symbols/symbol.svg",
  class: "icon-symbol",
});
Vue.use(VueFlags, {
  iconPath: "/images/flags/",
});

Sentry.init({
  Vue,
  dsn: "https://225bc18138294810ad8799074b65ed9e@oops.nixdate.com/13",
  environment: process.env.NODE_ENV,
  integrations: [
    new Sentry.BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracePropagationTargets: [
        "localhost",
        /^https:\/\/([a-zA-Z0-9-]+\.)?partner\.house\/api/,
      ],
    }),
  ],
});
Vue.use(Notifications);
Vue.component("multiselect", Multiselect);
Vue.component("default-layout", DefaultLayout);
Vue.component("panel-layout", PanelLayout);
Vue.component("auth-layout", AuthLayout);

new Vue({
  i18n,
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
